import { Button, Center, Stack, Text } from '@mantine/core';
import { X } from 'lucide-react';
import { clearThenFocusFilter } from '../../../utils/focusFilterTrigger';
import classes from './DataLibraryEmptyState.module.css';

interface DataLibraryEmptyStateProps {
  /** Shown when no filter or search is set */
  message: string;
  hasActiveFilters: boolean;
  onClearFilters: () => void;
}

/**
 * MDF-39: the empty state of a Data Library table. It sits below the table, not in a table cell,
 * so a table wider than the screen cannot push it out of view.
 */
export function DataLibraryEmptyState({ message, hasActiveFilters, onClearFilters }: DataLibraryEmptyStateProps) {
  return (
    <Center py={60} px="md" className={classes.emptyState}>
      <Stack align="center" gap="sm">
        <Text c="dimmed" size="lg" ta="center">
          {hasActiveFilters ? 'No records match these filters' : message}
        </Text>
        {hasActiveFilters && (
          <Button variant="subtle" size="sm" leftSection={<X size={14} />} onClick={clearThenFocusFilter(onClearFilters)}>
            Clear filters
          </Button>
        )}
      </Stack>
    </Center>
  );
}
